export class Alert {
  name: string;
  priority: number;
  alertType: string;
  summary: string;
  detailedDescription: string;
  notes: string[];
  startDate: Date;
  endDate: Date;
  status: StatusEnum;

  constructor(name: string, priority: number, alertType: string,
              summary: string, detailedDescription: string, notes: string[], startDate: Date,
              endDate: Date, status: StatusEnum) {
    this.name = name;
    this.priority = priority;
    this.alertType = alertType;
    this.summary = summary;
    this.detailedDescription = detailedDescription;
    this.notes = notes;
    this.startDate = startDate;
    this.endDate = endDate;
    this.status = status;
  }
}

export enum StatusEnum {
  viewable,
  hidden,
  resolved
}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/Alert.ts